// material-ui
import { useTheme, styled } from '@mui/material/styles';
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Stack,
  Typography
} from '@mui/material';

// assets
import { IconBrandTelegram, IconBuildingStore, IconMailbox, IconPhoto } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
// styles
const ListItemWrapper = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  padding: 16,
  '&:hover': {
    background: theme.palette.primary.light
  },
  '& .MuiListItem-root': {
    padding: 0
  }
}));

// ==============================|| NOTIFICATION LIST ITEM ||============================== //

const NotificationList = ({data:data,onClick:onClick}) => {
  const theme = useTheme();
const navigate = useNavigate()
  const chipSX = {
    height: 24,
    padding: '0 6px'
  };
  const chipErrorSX = {
    ...chipSX,
    color: "#fff",
    backgroundColor: "orange",
    marginRight: '5px'
  };

  // const chipWarningSX = {
  //   ...chipSX,
  //   color: theme.palette.warning.dark,
  //   backgroundColor: theme.palette.warning.light
  // };

  const chipSuccessSX = {
    ...chipSX,
    color: "#00ae48",
    backgroundColor: "#d8ffe3",
    height: 28
  };

  function timeAgo(dateString) {
    const now = new Date();
    const date = new Date(dateString);
    const differenceInSeconds = Math.floor((now - date) / 1000);

    if (isNaN(differenceInSeconds) || differenceInSeconds < 0) {
        return "0 seconds ago";
    } else if (differenceInSeconds < 60) {
        return `${differenceInSeconds} seconds ago`;
    } else if (differenceInSeconds < 3600) {
        const minutes = Math.floor(differenceInSeconds / 60);
        return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
    } else if (differenceInSeconds < 86400) {
        const hours = Math.floor(differenceInSeconds / 3600);
        return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
    } else {
        const days = Math.floor(differenceInSeconds / 86400);
        return `${days} ${days === 1 ? 'day' : 'days'} ago`;
    }
}

  return (
    <List
    sx={{
      width: "100%",
      minWidth: 330,
      py: 0,
      borderRadius: '10px',
      [theme.breakpoints.down('md')]: {
        maxWidth: 300
      },
      '& .MuiListItemSecondaryAction-root': {
        top: 22
      },
      '& .MuiDivider-root': {
        my: 0
        
      }
      
    }}
    >
      {data.slice(0,10).map((item)=>(
        <>
         <ListItemWrapper  key={item.id} onClick={()=>onClick(item._id,item.userId,item.route)} >
         <ListItem sx={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
           {/* <ListItemAvatar>
             <Avatar alt="John Doe"  />
           </ListItemAvatar> */}
           <ListItemText  primary={item.name} />
           <ListItemSecondaryAction>
             <Grid container justifyContent="flex-end">
               <Grid item xs={12}>
                 <Typography variant="caption" display="block" gutterBottom>
                 {timeAgo(item.created_at)}
                 </Typography>
               </Grid>
             </Grid>
           </ListItemSecondaryAction>
         </ListItem>
         <Grid container direction="column" className="list-container">
           <Grid item xs={12} >
             <Typography fontSize={12} variant="subtitle2">{item.message}</Typography>
           </Grid>
           <Grid item xs={12}  >
             <Grid container>
               <Grid item>
                
                 <Chip label={item.status} sx={item.status==="unread"?chipErrorSX:chipSuccessSX} />
               </Grid>
               <Grid item>
                 {/* <Chip label="New" sx={chipWarningSX} /> */}
               </Grid>
             </Grid>
           </Grid>
         </Grid>
       </ListItemWrapper>
       <Divider />
       </>
      ))}
     
     
    </List>
  );
};

export default NotificationList;
